import React, { useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { australianStates } from '../../helpers/form';
import Country from '../../enums/Country';

const State = props => {

  const [province, setProvince] = useState('')
  
  useEffect(()=>{

    let foundState = australianStates.find(
      state => state.value === props.value
    );

    foundState = foundState ? foundState.value : '';
    setProvince(foundState)
  },[props.countryCode, props.value])

  return (
    props.countryCode === Country.Australia 
      ?(
        <div className={props.className}>

          <FormControl variant='standard' fullWidth>
            <InputLabel
              id={`${props.name}-select`}
              error={!!props.errors}
            >
              State
            </InputLabel>
            <Select
              labelId={`${props.name}-select`}
              error={!!props.errors}
              className={props.errors ? 'form-error' : ''}
              label={props.name}
              name={props.name}
              value={province}
              options={australianStates}
              onChange={props.onChange}
              disabled={props.disabled}
            >
              { !australianStates.length ? null : australianStates.map(state => {
                return (
                  <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>
                )
              })}
            </Select>
            {props.errors ? <FormHelperText htmlFor={`${props.name}-select`} error>{props.errors}</FormHelperText> : false}
          </FormControl>
        </div>
      )
      :(
        <div className={props.className}>
          <TextField
            error={props.errors && props.errors.length > 0}
            helperText={props.errors[0]}
            label="State / Region / Province"
            fullWidth
            name={props.name}
            onChange={props.onChange}
            type="text"
            value={props.value}
            variant='standard'
            disabled={props.disabled}
          />
        </div>
      )
  )
}

export default State;